import React from "react";
import { Form, Button, useClasses, Row } from "../";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faSpinnerThird, faTriangleExclamation, } from "@fortawesome/pro-duotone-svg-icons";
import useI18n from "../hooks/useI18n";
import classNames from "classnames";
const styes = (theme) => ({
    wrapper: {
        position: "relative",
    },
    overlay: {
        zIndex: 3,
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        padding: "32px 0px 0px 0px",
    },
    content: {
        position: "sticky",
        top: "16px",
        textAlign: "center",
    },
    icon: {
        fontSize: "5rem",
    },
    pending: {
        color: theme.palette.get("primary"),
    },
    error: {
        color: theme.palette.get("danger"),
    },
    success: {
        color: theme.palette.get("success"),
        fontSize: "8rem",
    },
});
export default function StateHandler(props) {
    var _a, _b, _c;
    const classes = useClasses(styes);
    const i18n = useI18n(props.translationGroup || "stateHandler");
    const override = props.override;
    return (React.createElement("div", { className: classNames([classes.wrapper, override === null || override === void 0 ? void 0 : override.wrapper]) },
        props.state !== "ok" && (React.createElement("div", { className: classNames([classes.overlay, override === null || override === void 0 ? void 0 : override.overlay]) },
            React.createElement("div", { className: classNames([classes.content, override === null || override === void 0 ? void 0 : override.content]) },
                props.state === "pending" && (React.createElement(FontAwesomeIcon, { className: classNames([
                        classes.icon,
                        (_a = props.override) === null || _a === void 0 ? void 0 : _a.icon,
                        classes.pending,
                    ]), icon: faSpinnerThird, spin: true })),
                props.state === "error" && (React.createElement(Form, { horizontalAlign: "center", onSubmit: (e) => e.preventDefault() },
                    React.createElement(FontAwesomeIcon, { className: classNames([
                            classes.icon,
                            (_b = props.override) === null || _b === void 0 ? void 0 : _b.icon,
                            classes.error,
                        ]), icon: faTriangleExclamation }),
                    React.createElement("p", null,
                        i18n.get("a"),
                        " ",
                        React.createElement("b", null, i18n.get("unknown Error")),
                        React.createElement("br", null),
                        i18n.get("occurred"),
                        "!"),
                    typeof props.onErrorReset !== "undefined" && (React.createElement(Row, { horizontalAlign: "center" },
                        React.createElement(Button, { xs: "100px", onClick: () => {
                                if (props.onErrorReset)
                                    props.onErrorReset();
                            } }, i18n.get("back")))))),
                props.state === "success" && (React.createElement(FontAwesomeIcon, { className: classNames([
                        classes.icon,
                        (_c = props.override) === null || _c === void 0 ? void 0 : _c.icon,
                        classes.success,
                    ]), icon: faCheckCircle }))))),
        props.children));
}
